import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import makeArray from 'webapp/helpers/make-array';
import BoardTemplatesGridItemComponent from 'webapp/components/board/templates/grid-item';

import type Board from 'webapp/models-custom/board';

import type { TrackingOriginForTemplateCreated } from 'webapp/services/model-manager/boards';

interface Args {
	isHidden?: boolean;
}

const DEFAULT_EXTRA_ITEMS_SHOWN = 21;

export default class BoardTemplateRecommendedAccountTemplatesComponent extends Component<Args> {
	@service('account') declare accountService: Service.Account;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('model-manager/source-types')
	declare mmSourceTypesService: Service.ModelManager.SourceTypes;
	@service('model-manager/templates') declare mmTemplatesService: Service.ModelManager.Templates;
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('model-manager/boards') declare mmBoardsService: Service.ModelManager.Boards;

	maxShownExtraItems = DEFAULT_EXTRA_ITEMS_SHOWN;
	origin = 'recommended_account_templates';
	mainActionText = 'Save as template';

	get model(): Board[] {
		return this.mmBoardsService.normalBoardModels.slice(0, this.maxShownExtraItems);
	}

	get isShown() {
		return (
			!this.args.isHidden &&
			!this.accountService.hideDataboxNotWhiteLabeledContentForNonAdmins &&
			!this.currentUserService.isViewer
		);
	}

	onPreview = (board: Board) => {
		this.mmBoardsService.openPreview(board);
	};

	mainAction = (board: Board) => {
		board.openAccountTemplateEditPopup(this.origin as TrackingOriginForTemplateCreated);
	};

	@action
	browseMore() {
		this.navigationService.transitionToRoute('boards.index');
	}
	<template>
		{{#if this.isShown}}
			<div class="empty-screen-recommended">
				<div class="empty-screen-recommended__header">
					<h3>Start with dashboards you’ve created...</h3>
					<a role="button" {{on "click" this.browseMore}}>Browse more</a>
				</div>
				<div class="empty-screen-recommended__content">
					<ul class="flex-ct flex-ct--size-board">
						{{#each this.model as |boardModel|}}
							<BoardTemplatesGridItemComponent
								@model={{boardModel}}
								@mainAction={{this.mainAction}}
								@mainActionText={{this.mainActionText}}
								@onPreview={{this.onPreview}}
								@trackingOrigin={{this.origin}}
								@isVisibleOnScreen={{true}}
							/>
						{{/each}}

						{{! adding (max-in-line - 1) fake items so the incomplete last row items are not stretched too much }}
						{{#each (makeArray length=this.maxShownExtraItems)}}
							<li class="flex-item flex-item--fake"></li>
						{{/each}}
					</ul>
				</div>
			</div>
		{{/if}}
	</template>
}
